import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
const spacing = globalTheme.spacing;
export const theme = createTheme({
    bySize: {
        xs: { width: spacing.xs },
        sm: { width: spacing.sm },
        md: { width: spacing.md },
        lg: { width: spacing.lg },
        xl: { width: spacing.xl },
        xxl: { width: spacing.xxl },
    },
});
export const iconNextSizeVariant = createVariant((props) => theme.bySize[props.size]);
//# sourceMappingURL=theme.js.map